import { GET_FLIGHT_TEST_PLAN_SUCCESS, GET_SLOTS_FOR_LANDING_PAD } from "../actions/actionTypes";

export interface FlightTestPlan {
  id: string;
}
interface FlightTestPlanState {
  testPlans: any;
  landingPadSlots: {[key: number]: any};
}
const initialState: FlightTestPlanState = {
  testPlans: [],
  landingPadSlots: [],
};

const flightTestPlansReducer = (
  state = initialState,
  action: { type: string; payload: any }
): FlightTestPlanState => {
  switch (action.type) {
    case GET_FLIGHT_TEST_PLAN_SUCCESS: {
      return {
        ...state,
        testPlans: action.payload
      }
    }
    case GET_SLOTS_FOR_LANDING_PAD: {
      const newLandingPadSlots = Object.assign({}, state.landingPadSlots, {[action.payload.landingPadId]: action.payload.availability})
      return {
        ...state,
        landingPadSlots: newLandingPadSlots
      }
    }
    default:
      return state;
  }
};

export default flightTestPlansReducer;
